import moment from 'moment';

export default function daysTillNow(date, format) {
  return moment()
    .endOf('D')
    .diff(moment(date, format).startOf('D'), 'days');
}
